;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod/v4";

export const emailSignInSchema = z.object({
	email: z
		.email({ error: "Please enter a valid email address" })
		.toLowerCase()
		.trim(),
});

export const onboardingPersonalInfoSchema = emailSignInSchema.extend({
	companyAddress: z
		.string({ error: "Please enter your company address" })
		.min(1, { error: "Please enter your company address" }),
	companyName: z
		.string({ error: "Please enter your company name" })
		.min(1, { error: "Please enter your company name" }),
	firstName: z
		.string({ error: "Please enter your first name" })
		.min(1, { error: "Please enter your first name" }),
	lastName: z
		.string({ error: "Please enter your last name" })
		.min(1, { error: "Please enter your last name" }),
	phone: z
		.string({ error: "Please enter your phone number" })
		.min(1, { error: "Please enter your phone number" }),
});

export const onboardingWorkspaceViewsSchema = z.array(
	z
		.object({
			description: z.string().optional(),
			id: z.string().optional(),
			name: z.string(),
		})
		.loose(),
);

export const onboardingWorkspaceNameSchema = z.object({
	workspaceName: z
		.string({ error: "Please enter a workspace name" })
		.min(1, { error: "Please enter a workspace name" }),
});

export const onboardingWorkspaceSchema = onboardingWorkspaceNameSchema.extend({
	views: onboardingWorkspaceViewsSchema,
});

/** This is just defined as a type definition for the full onboarding form */
export const onboardingSchema = z.object({
	personalInfo: onboardingPersonalInfoSchema,
	workspace: onboardingWorkspaceSchema.extend({
		views: z.object({
			investors: z.boolean().optional(),
			leasing: z.boolean().optional(),
			prospects: z.boolean().optional(),
			receivables: z.boolean().optional(),
			workOrders: z.boolean().optional(),
		}),
	}),
});
